import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnDestroy, OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: contents;
}

@media (max-width: 1023px) {
  .sidebar-notification-button {
    width: 44px;
    height: 44px;
  }
  .sidebar-notification-popover {
    top: calc(4.5rem + env(safe-area-inset-top));
    display: flex;
    max-height: calc(100dvh - 5.25rem - env(safe-area-inset-top));
    flex-direction: column;
  }
  .sidebar-notification-list {
    min-height: 0;
    flex: 1 1 auto;
  }
  .sidebar-account-action,
  nav a {
    min-height: 44px;
  }
}`],
})
export class ComponentNavSidebarComponent implements OnInit, OnDestroy {
    public profileImage: string = '';
    public notifications: any[] = [];
    public unreadCount: number = 0;
    public notificationOpen: boolean = false;
    public notificationLoading: boolean = false;
    public pushSupported: boolean = false;
    public pushState: string = 'loading';
    public pushMessage: string = '';
    public pushBusy: boolean = false;
    private pushPublicKey: string = '';
    private pushRegistration: ServiceWorkerRegistration | null = null;
    private notificationTimer: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await Promise.all([
            this.loadProfile(),
            this.loadNotifications(),
            this.initializePush()
        ]);
        this.notificationTimer = setInterval(
            () => this.loadNotifications(),
            30000
        );
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.notificationTimer) {
            clearInterval(this.notificationTimer);
        }
    }

    private async loadProfile() {
        const { code, data } = await wiz.call('profile');
        if (code === 200) {
            this.profileImage = data?.profile_image || '';
        }
    }

    private async pushApi(action: string, params: any = {}) {
        try {
            const body = new URLSearchParams();
            Object.keys(params).forEach((key) => {
                body.set(key, String(params[key] ?? ''));
            });
            const response = await fetch(
                `/wiz/api/component.nav.sidebar/${action}`,
                {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': (
                            'application/x-www-form-urlencoded;charset=UTF-8'
                        )
                    },
                    body: body.toString()
                }
            );
            return await response.json();
        } catch (error) {
            return { code: 0, data: {} };
        }
    }

    private async loadPushPublicKey() {
        const response = await this.pushApi('push_config');
        if (
            response.code === 200
            && response.data?.enabled
            && response.data?.public_key
        ) {
            return response.data.public_key;
        }

        const workerResponse = await fetch('/sw.js', { cache: 'no-store' });
        if (!workerResponse.ok) return '';
        const workerSource = await workerResponse.text();
        const match = workerSource.match(
            /MOATIME_VAPID_PUBLIC_KEY\s*=\s*['"]([^'"]+)['"]/
        );
        return match?.[1] || '';
    }

    private isStandalone() {
        const nav: any = navigator;
        return (
            window.matchMedia('(display-mode: standalone)').matches
            || nav.standalone === true
        );
    }

    private setPushDeniedState() {
        if (!this.isStandalone()) {
            this.pushState = 'hidden';
            this.pushMessage = '';
            return;
        }

        this.pushState = 'denied';
        this.pushMessage = (
            'MoaTime 앱의 기기 설정에서 알림을 허용해주세요.'
        );
    }

    private async initializePush() {
        if (!this.isStandalone()) {
            this.pushState = 'hidden';
            this.pushMessage = '';
            return;
        }

        this.pushSupported = (
            'serviceWorker' in navigator
            && 'PushManager' in window
            && 'Notification' in window
        );
        if (!this.pushSupported) {
            this.pushState = 'unsupported';
            this.pushMessage = '이 기기에서는 웹 푸시 알림을 지원하지 않습니다.';
            return;
        }

        try {
            this.pushPublicKey = await this.loadPushPublicKey();
            if (!this.pushPublicKey) {
                this.pushState = 'unavailable';
                this.pushMessage = '휴대폰 알림 서버를 사용할 수 없습니다.';
                return;
            }
            this.pushRegistration = await navigator.serviceWorker.register(
                '/sw.js',
                { scope: '/' }
            );
            const subscription = await this.pushRegistration.pushManager
                .getSubscription();
            if (Notification.permission === 'denied') {
                this.setPushDeniedState();
                return;
            }
            if (subscription) {
                await this.syncPushSubscription(subscription);
                return;
            }
            this.pushState = 'ready';
            this.pushMessage = '새 모임 소식을 휴대폰 알림센터에서 받아보세요.';
        } catch (error) {
            this.pushState = 'unavailable';
            this.pushMessage = '휴대폰 알림 설정을 불러오지 못했습니다.';
        }
    }

    private urlBase64ToUint8Array(value: string) {
        const padding = '='.repeat((4 - value.length % 4) % 4);
        const base64 = (value + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        const raw = window.atob(base64);
        return Uint8Array.from(
            Array.from(raw).map((character) => character.charCodeAt(0))
        );
    }

    private async syncPushSubscription(subscription: PushSubscription) {
        const serialized: any = subscription.toJSON();
        const { code, data } = await this.pushApi('subscribe_push', {
            endpoint: serialized.endpoint || subscription.endpoint,
            p256dh: serialized.keys?.p256dh || '',
            auth: serialized.keys?.auth || '',
            user_agent: navigator.userAgent
        });
        if (code === 200 && data?.subscribed) {
            localStorage.removeItem('moatime-push-sync-pending');
            this.pushState = 'subscribed';
            this.pushMessage = '휴대폰 알림이 켜져 있습니다.';
            return;
        }
        localStorage.setItem('moatime-push-sync-pending', '1');
        this.pushState = 'subscribed-pending';
        this.pushMessage = (
            '기기 알림은 켜졌으며 서버 연결 시 자동으로 동기화됩니다.'
        );
    }

    public async enablePushNotifications(event: Event) {
        event.stopPropagation();
        if (this.pushBusy) return;
        this.pushBusy = true;
        this.pushMessage = '';

        try {
            const permission = await Notification.requestPermission();
            if (permission !== 'granted') {
                this.setPushDeniedState();
                return;
            }
            if (!this.pushRegistration) {
                this.pushRegistration = await navigator.serviceWorker.register(
                    '/sw.js',
                    { scope: '/' }
                );
            }
            let subscription = await this.pushRegistration.pushManager
                .getSubscription();
            if (!subscription) {
                subscription = await this.pushRegistration.pushManager
                    .subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: this.urlBase64ToUint8Array(
                            this.pushPublicKey
                        )
                    });
            }
            await this.syncPushSubscription(subscription);
        } catch (error) {
            this.pushState = 'ready';
            this.pushMessage = '알림을 켜지 못했습니다. 잠시 후 다시 시도해주세요.';
        } finally {
            this.pushBusy = false;
            await this.service.render();
        }
    }

    public async disablePushNotifications(event: Event) {
        event.stopPropagation();
        if (this.pushBusy || !this.pushRegistration) return;
        this.pushBusy = true;
        await this.service.render();

        try {
            const subscription = await this.pushRegistration.pushManager
                .getSubscription();
            if (subscription) {
                await this.pushApi('unsubscribe_push', {
                    endpoint: subscription.endpoint
                });
                await subscription.unsubscribe();
            }
            this.pushState = 'ready';
            this.pushMessage = '새 모임 소식을 휴대폰 알림센터에서 받아보세요.';
        } catch (error) {
            this.pushMessage = '알림 해제를 완료하지 못했습니다.';
        } finally {
            this.pushBusy = false;
            await this.service.render();
        }
    }

    public async logout(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        try {
            if (this.pushRegistration) {
                const subscription = await this.pushRegistration.pushManager
                    .getSubscription();
                if (subscription) {
                    await this.pushApi('unsubscribe_push', {
                        endpoint: subscription.endpoint
                    });
                    await subscription.unsubscribe();
                }
            }
        } finally {
            window.location.href = '/auth/logout';
        }
    }

    public async loadNotifications(showLoading: boolean = false) {
        if (showLoading) {
            this.notificationLoading = true;
            await this.service.render();
        }
        const { code, data } = await wiz.call('list_notifications', {
            limit: 30
        });
        if (code === 200) {
            this.notifications = data?.notifications || [];
            this.unreadCount = Number(data?.unread_count || 0);
        }
        this.notificationLoading = false;
        await this.service.render();
    }

    public async toggleNotifications(event: Event) {
        event.stopPropagation();
        this.notificationOpen = !this.notificationOpen;
        if (this.notificationOpen) {
            await this.loadNotifications(true);
        } else {
            await this.service.render();
        }
    }

    public async openNotification(notification: any, event: Event) {
        event.stopPropagation();
        if (!notification?.is_read) {
            const { code } = await wiz.call('mark_notification_read', {
                id: notification.id
            });
            if (code === 200) {
                notification.is_read = true;
                this.unreadCount = Math.max(0, this.unreadCount - 1);
            }
        }
        this.notificationOpen = false;
        await this.service.status.toggle('navbar', false);
        await this.service.render();
        if (notification?.link) {
            await this.router.navigateByUrl(notification.link);
        }
    }

    public async markAllNotificationsRead(event: Event) {
        event.stopPropagation();
        if (this.unreadCount === 0) return;
        const { code } = await wiz.call('mark_all_notifications_read');
        if (code === 200) {
            this.notifications = this.notifications.map(
                (notification: any) => ({
                    ...notification,
                    is_read: true
                })
            );
            this.unreadCount = 0;
            await this.service.render();
        }
    }

    public async openNotificationsPage(event: Event) {
        event.stopPropagation();
        this.notificationOpen = false;
        await this.service.status.toggle('navbar', false);
        await this.service.render();
        await this.router.navigateByUrl('/notifications');
    }

    public notificationTime(value: any) {
        const created = this.kstDate(value);
        if (isNaN(created.getTime())) return '';
        const seconds = Math.max(
            0,
            Math.floor((Date.now() - created.getTime()) / 1000)
        );
        if (seconds < 60) return '방금 전';
        if (seconds < 3600) return `${Math.floor(seconds / 60)}분 전`;
        if (seconds < 86400) return `${Math.floor(seconds / 3600)}시간 전`;
        if (seconds < 604800) return `${Math.floor(seconds / 86400)}일 전`;
        return new Intl.DateTimeFormat('ko-KR', {
            month: 'numeric',
            day: 'numeric',
            timeZone: 'Asia/Seoul'
        }).format(created);
    }

    private kstDate(value: any) {
        const raw = String(value || '').trim();
        if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/.test(raw)) {
            return new Date(`${raw.replace(' ', 'T')}+09:00`);
        }
        return new Date(value);
    }

    public notificationIconClass(eventType: string) {
        if ((eventType || '').startsWith('poll')) {
            return 'bg-amber-50 text-amber-600';
        }
        if (
            (eventType || '').startsWith('schedule')
            || eventType === 'itinerary_updated'
        ) {
            return 'bg-blue-50 text-blue-600';
        }
        if (eventType === 'meeting_deleted' || eventType === 'member_removed') {
            return 'bg-red-50 text-red-600';
        }
        return 'bg-violet-50 text-violet-600';
    }

    public avatarImage() {
        return this.service.auth.session?.profile_image || this.profileImage;
    }

    @HostListener('document:click')
    public clickout() {
        this.notificationOpen = false;
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-2 items-center rounded-md bg-violet-50 px-2 py-2 text-[13px] font-bold text-violet-600";
        }
        return "group flex gap-x-2 items-center rounded-md px-2 py-2 text-[13px] font-semibold text-slate-600 hover:bg-slate-50 hover:text-violet-600";
    }
}

export default ComponentNavSidebarComponent;